import { useLocation } from 'react-router-dom';
import { useT } from '@dia/i18n';
import { HelpThreadPage } from './parts/HelpThreadPage';
import { isProblemReport } from './logic/helpSheet';

/**
 * /pedidos, the old Requests address. It still works (no address is removed,
 * docs/GUEST-REDESIGN.md), and it now draws the one help thread the sheet
 * draws, with the composer open on "Ask for something". With ?tipo=problema it
 * opens on "Report a problem" instead, with room for a photo.
 */
export function Requests() {
  const { t } = useT();
  const { search } = useLocation();
  const problem = isProblemReport(search);

  return (
    <HelpThreadPage
      title={problem ? t('guest.request.problem_title') : t('guest.request.title')}
      lede={problem ? t('guest.request.problem_lede') : t('guest.request.lede')}
      mode={problem ? 'problem' : 'ask'}
      signInFirst={t('guest.request.sign_in_first')}
      locked={t('guest.request.locked')}
    />
  );
}
